function Home(): JSX.Element {
  return <div></div>;
}

export default Home;
